import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import IncompleteAssessmentSection from './IncompleteAssessmentSection';
import { invalidAssessmentError } from './helpers.js';

const TranscriptText = ({ assessmentData, assessmentError, fullText }) => {
  const text = assessmentData?.formattedTranscription?.fullText || '';
  const truncatedText =
    fullText || text?.length < 210 ? text : `${text.substring(0, 210)}...`;

  if (assessmentData.transcriptionStatus !== 'complete') {
    return (
      <IncompleteAssessmentSection
        status={assessmentData.transcriptionStatus}
        error={assessmentError}
        processText={t('automated_analysis.transcript.title')}
        invalidAssessmentError={invalidAssessmentError(assessmentData)}
      />
    );
  }
  return (
    <div className="lh-36">
      <Text variant={TEXT_VARIANTS.BODY}>{truncatedText}</Text>
    </div>
  );
};

export default TranscriptText;
